import React from 'react';
import {sx} from "./sx";
import {useTranslation} from "react-i18next";
import {Typography} from "@mui/material";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    message?: string,
    sx?:SxType
}

const NotItems = ({message,sx:sxProps={}}: IProps) => {
    const {t} = useTranslation()

    return (
        <Typography
            sx={{
                ...sx.root,
                ...sxProps
            }}
            variant={'body2'}
        >
            {message || t('notFound')}
        </Typography>
    )
};

export default NotItems;